export const FileBackupsConstantsV1 = {
    Version: '1.0.0',
    MetadataFileName: 'metadata.sn.json',
    BinaryFileName: 'file.encrypted',
};
